import { render, staticRenderFns } from "./colorTest.vue?vue&type=template&id=a92fdb78&scoped=true&"
import script from "./colorTest.vue?vue&type=script&lang=js&"
export * from "./colorTest.vue?vue&type=script&lang=js&"
import style0 from "./colorTest.vue?vue&type=style&index=0&id=a92fdb78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a92fdb78",
  null
  
)

export default component.exports